import { render, staticRenderFns } from "./CConfirmationDialog.vue?vue&type=template&id=728b0d0c"
import script from "./CConfirmationDialog.vue?vue&type=script&lang=js"
export * from "./CConfirmationDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports